module.exports = __webpack_public_path__ + "media/_archive/W-bf253c54.png";